"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
  _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
  _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
  _react = _interopRequireWildcard(require("react")),
  _DatePicker = _interopRequireDefault(require("./DatePicker")),
  _DateSelect = _interopRequireDefault(require("./DateSelect")),
  _DateInput = _interopRequireDefault(require("./DateInput")),
  _InputLabel = _interopRequireDefault(require("../../FormElements/InputLabel")),
  _excluded = ["field", "value", "validationMessage", "touched", "setTouched", "hideField", "updateForm", "styledComponents", "error", "unsetError", "setFocusClass", "cssClass"];
function _getRequireWildcardCache(a) {
  if ("function" != typeof WeakMap) return null;
  var b = new WeakMap(),
    c = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(a) {
    return a ? c : b;
  })(a);
}
function _interopRequireWildcard(b, c) {
  if (!c && b && b.__esModule) return b;
  if (null === b || "object" != _typeof(b) && "function" != typeof b) return {
    default: b
  };
  var d = _getRequireWildcardCache(c);
  if (d && d.has(b)) return d.get(b);
  var e = {
      __proto__: null
    },
    f = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in b) if ("default" != a && Object.prototype.hasOwnProperty.call(b, a)) {
    var g = f ? Object.getOwnPropertyDescriptor(b, a) : null;
    g && (g.get || g.set) ? Object.defineProperty(e, a, g) : e[a] = b[a];
  }
  return e["default"] = b, d && d.set(b, e), e;
}
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
var _default = exports["default"] = function (a) {
  var b = a.field,
    c = a.value,
    d = a.validationMessage,
    e = a.touched,
    f = a.setTouched,
    g = a.hideField,
    h = a.updateForm,
    i = a.styledComponents,
    j = a.error,
    k = a.unsetError,
    l = a.setFocusClass,
    m = a.cssClass,
    n = (0, _objectWithoutProperties2["default"])(a, _excluded),
    o = b.id,
    p = b.formId,
    q = b.type,
    r = b.label,
    s = b.isRequired,
    t = b.description,
    u = b.descriptionPlacement,
    v = b.labelPlacement,
    w = b.width,
    x = b.inputs,
    y = b.dateType,
    z = b.dateFormat,
    A = b.defaultValue,
    B = (i || !1).Box,
    C = void 0 === B ? "div" : B,
    D = !!(z && "dmy" === z) && "dd/MM/yyyy",
    E = !!A && new Date(A);
  if (D && A) {
    var F = -1 < A.indexOf("/"),
      G = F ? A.split("/") : A.split("-"),
      H = F ? new Date(+G[2], G[1] - 1, +G[0]) : G;
    E = H;
  }
  var I = (0, _react.useState)(E),
    J = (0, _slicedToArray2["default"])(I, 2),
    K = J[0],
    L = J[1],
    M = function getFormattedInputs(a) {
      if (y) {
        if ("datefield" === y) return "dmy" === z || "dmy_dash" === z || "dmy_dot" === z ? [a[1], a[0], a[2]] : "ymd_slash" === z || "ymd_dash" === z || "ymd_dot" === z ? [a[2], a[0], a[1]] : a;
        if ("datedropdown" === y) return [a[1], a[0], a[2]];
      }
      return a;
    }(x),
    N = _objectSpread({
      id: o,
      field: b,
      isRequired: s,
      format: D,
      formattedInputs: M,
      updateForm: h,
      startDate: K,
      setTouched: f,
      setDate: L,
      setFocusClass: l,
      error: j,
      unsetError: k,
      validationMessage: d,
      styledComponents: i,
      touched: e
    }, n);
  return _react["default"].createElement(C, {
    width: w,
    className: d && e || j ? "form-field error ".concat(m) : "form-field ".concat(m),
    style: {
      display: g ? "none" : void 0
    }
  }, _react["default"].createElement(_InputLabel["default"], {
    formId: p,
    id: o,
    label: r,
    labelPlacement: v,
    isRequired: s,
    styledComponent: i
  }), _react["default"].createElement("div", {
    className: q
  }, "above" === u && t && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: t
    }
  }), y && function renderDateField(a) {
    return "datepicker" === a ? _react["default"].createElement(_DatePicker["default"], {
      defaultProps: N
    }) : "datedropdown" === a ? _react["default"].createElement(_DateSelect["default"], {
      defaultProps: N
    }) : _react["default"].createElement(_DateInput["default"], {
      defaultProps: N
    });
  }(y), "above" !== u && t && _react["default"].createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: t
    }
  })));
};